import React from 'react';
import { PurchaseOrderListDrawer } from '../../Common';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';
import { getHistoryStatusLabel } from '../utils';

interface Props {
  purchaseOrders: CapaQuotationRfqPurchaseOrder[];
  onClick: (id: string) => void;
}

const PurchaseOrderViewListDrawerPresenter = ({
  purchaseOrders,
  onClick
}: Props) => {
  const items = purchaseOrders.map((item) => ({
    id: item.id ?? '',
    dueDate: item.shipDate ?? '',
    createdAt: item.createdAt ?? '',
    quotationPrice: item.quotation ?? 0,
    isLatest: item.latest ?? false,
    isRejected: item.isRejected ?? false,
    statusLabel: getHistoryStatusLabel(item.status)
  }));

  return (
    <PurchaseOrderListDrawer title="발주이력" items={items} onClick={onClick} />
  );
};

export default PurchaseOrderViewListDrawerPresenter;
